import { useEffect } from 'react';
import { useModalContext } from 'components/system/ModalContext';
import NotEnoughFunds from 'components/pages/NotEnoughFunds';
import usePaymentsStore from 'store/paymentStore';
import PaymentMethodForm from 'components/pages/Payments/PaymentMethodForm';
import AddBalanceForm from 'components/pages/Payments/AddBalanceForm';
import usePaymentMethod from 'hooks/usePaymentMethod';
import { useGetBalance } from 'hooks/useBillingAccount';
import colors from 'styles/colors';

const attachCardMessages = {
  title: 'Attach your credit card',
  greeting: 'You’ve gone a long way so far!',
  message: 'To keep going and run quantum, please attach your credit card.',
  buttonLabel: 'Attach credit card',
};

const addFundsMessages = {
  title: 'Not enough funds',
  greeting: 'You’ve made great progress!',
  message: 'To keep going and run quantum, please add funds to your balance.',
  buttonLabel: 'Add balance',
};

const withNotEnoughFundsDialog = (Component) => ({ ...props }) => {
  const {
    hasPromo,
  } = usePaymentsStore((state) => state.balance);

  const {
    setModalContent, setPaperProps, openModal, closeModal,
  } = useModalContext();

  const { refetch: refetchPaymentMethod } = usePaymentMethod();
  const { refetch: refetchBalance } = useGetBalance();

  const {
    card, isLoading: paymentMethodLoading, isRefetching: isPaymentMethodRefetching,
  } = usePaymentsStore((state) => state.paymentMethod);

  const {
    credit, total: balance, isLoading: balanceLoading, isRefetching: isBalanceRefetching,
  } = usePaymentsStore((state) => state.balance);

  const textProps = hasPromo || card?.id ? addFundsMessages : attachCardMessages;

  const openAddBalanceModal = () => {
    setPaperProps({ style: { background: colors.background.paper_5p } });
    setModalContent(
      <AddBalanceForm onBalanceUpdate={closeModal} />,
    );
  };

  const openAttachCardModal = (modalProps) => {
    setPaperProps({ style: { background: colors.background.paper_5p } });
    setModalContent((
      <PaymentMethodForm
        contentLoading={paymentMethodLoading || balanceLoading}
        onSubmitCallback={async () => {
          await refetchBalance();
          await refetchPaymentMethod();
          openAddBalanceModal();
        }}
        {...modalProps}
      />
    ));
  };

  const onButtonClick = () => {
    if (card && credit <= 0 && balance <= 0) {
      openAddBalanceModal({
        isClosable: false,
      });
    } else {
      openAttachCardModal();
    }
  };

  const openNotEnoughFundsDialog = () => {
    openModal({
      content: (
        <NotEnoughFunds
          card={card}
          onButtonClick={onButtonClick}
          {...textProps}
        />
      ),
    });
  };

  useEffect(() => {
    if (!isPaymentMethodRefetching && !isBalanceRefetching) {
      if (card && credit <= 0 && balance <= 0) {
        setModalContent((
          <AddBalanceForm
            onBalanceUpdate={closeModal}
          />
        ));
      } else {
        closeModal();
      }
    }
  }, [card, credit, balance, paymentMethodLoading, isPaymentMethodRefetching, isBalanceRefetching]);

  return (

    <Component
      {...props}
      openNotEnoughFundsDialog={openNotEnoughFundsDialog}
    />
  );
};

export default withNotEnoughFundsDialog;
